module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.arrow),
      callback: function($$v) {
        _vm.arrow = $$v
      },
      expression: "arrow"
    }
  }, [_vm._v("Arrow")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowHover),
      callback: function($$v) {
        _vm.arrowHover = $$v
      },
      expression: "arrowHover"
    }
  }, [_vm._v("Arrow on hover")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.drag),
      callback: function($$v) {
        _vm.drag = $$v
      },
      expression: "drag"
    }
  }, [_vm._v("Drag event")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": _vm.opacity
    },
    model: {
      value: (_vm.gray),
      callback: function($$v) {
        _vm.gray = $$v
      },
      expression: "gray"
    }
  }, [_vm._v("Grayscale")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": _vm.gray
    },
    model: {
      value: (_vm.opacity),
      callback: function($$v) {
        _vm.opacity = $$v
      },
      expression: "opacity"
    }
  }, [_vm._v("Opacity")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = $$v
      },
      expression: "repeat"
    }
  }, [_vm._v("Repeat")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Value"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.items.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Items to List"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.items.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.perList),
      callback: function($$v) {
        _vm.perList = $$v
      },
      expression: "perList"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-carousel-list', {
    attrs: {
      "data": _vm.items,
      "arrow": _vm.arrow,
      "arrow-hover": _vm.arrowHover,
      "items-to-list": _vm.perList,
      "repeat": _vm.repeat,
      "has-drag": _vm.drag,
      "has-grayscale": _vm.gray,
      "has-opacity": _vm.opacity
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dca2fba"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/carousel/examples/ExCarouselList.vue
// module id = 997
// module chunks = 3 166